module.exports = __webpack_public_path__ + "static/media/cv.c56c579e.png";